import React from "react";

export const guideSectionTitleClass = "m-0 text-lg font-semibold text-[#dd6435]";
export const guideBodyClass = "m-0 text-sm leading-relaxed text-[#3d4754]";

export function GuideSection({
  id,
  title,
  children,
}: {
  id: string;
  title: string;
  children: React.ReactNode;
}) {
  return (
    <section id={id} className="flex flex-col gap-3">
      <h3 className={guideSectionTitleClass}>{title}</h3>
      {children}
    </section>
  );
}
